import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import AuthLayout from "layouts/AuthLayout";

import EmailSend from "./EmailSend";
import ForgotPasswordForm from "./ForgotPasswordForm";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { setIsEmailSent } from "store/features/authSlice";

const ForgotPassword: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const isEmailSent = useAppSelector((state) => state.auth.isEmailSent);
  const [email, setEmail] = useState<string>("");

  useEffect(() => {
    const email = location.state?.email || "";

    if (email) {
      setEmail(email);
    }

    return () => {
      setEmail("");
      dispatch(setIsEmailSent(false));
    };
  }, [dispatch, location.state?.email]);

  return (
    <AuthLayout>
      <Paper sx={{ width: { xs: "100%", sm: "480px" }, m: 2 }}>
        {isEmailSent ? (
          <EmailSend />
        ) : (
          <Box>
            <Typography sx={{ mb: 1 }} variant="h5">
              Відновлення пароля
            </Typography>
            <Typography sx={{ mb: 3 }} variant="body1" color="grey700">
              Для відновлення пароля вкажіть e-mail адресу, яку ви
              використовували при реєстрації. На цю адресу ми відправимо ваш
              пароль.
            </Typography>

            <ForgotPasswordForm email={email} setEmail={setEmail} />
          </Box>
        )}
      </Paper>
    </AuthLayout>
  );
};

export default ForgotPassword;
